function syncPrice() {
    const selected = document.querySelector(".Avada-Volume__Item--Selected");
    if (!selected) return;

    const sale = selected.querySelector(".AOV-Offer__DiscountPrice")?.innerText.trim();
    const mrp  = selected.querySelector(".AOV-Offer__BasePrice")?.innerText.trim();

    if (sale) {
        document.querySelector(".price-item--sale").textContent = sale;
    }

    if (mrp) {
        const regular = document.querySelectorAll(".price-item--regular");
        if (regular.length > 1) {
            regular[1].textContent = mrp;
        }
    }
}

// Observe all changes inside the selected bundle
function observeSelectedBundle() {

    const selected = document.querySelector(".Avada-Volume__Item--Selected");
    if (!selected) return;

    const observer = new MutationObserver(() => {
        syncPrice();
    });

    observer.observe(selected, {
        subtree: true,
        childList: true,
        characterData: true
    });
}

// Bundle changes
document.addEventListener("click", function(e){

    if (e.target.closest(".Avada-Volume__Item")) {

        setTimeout(() => {
            syncPrice();
            observeSelectedBundle();
        },300);

    }

});

window.addEventListener("load", () => {
    syncPrice();
    observeSelectedBundle();
});